import React, { FC, MouseEventHandler } from "react"
import styled from "styled-components"
import L10n from "../../../../lib/carrot-l10n"
import { Button } from "./Button"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CloseButtonMobileOnlyStyledWrapper = styled.div`
  @media screen and (min-width: 596px) {
    display: none;
  }
  @media screen and (max-width: 595px) {
    position: absolute;
    bottom: 24px;
    right: 24px;
  }
`

const CloseButtonStyledWrapper = styled.div`
  @media screen {
    position: absolute;
    bottom: 24px;
    right: 24px;
  }
`

type CloseButtonProps = {
  onClose?: MouseEventHandler<HTMLAnchorElement>
  showInDesktopView: boolean
}

const CloseButton: FC<CloseButtonProps> = ({ onClose, showInDesktopView = false }) => (
  <div style={{ height: 89 }}>
    {showInDesktopView ? (
      <CloseButtonStyledWrapper>
        <Button outline onClick={onClose} enabled>
          {l`fle.close`}
        </Button>
      </CloseButtonStyledWrapper>
    ) : (
      <CloseButtonMobileOnlyStyledWrapper>
        <Button outline onClick={onClose} enabled>
          {l`fle.close`}
        </Button>
      </CloseButtonMobileOnlyStyledWrapper>
    )}
  </div>
)

export { CloseButton }
